const sortString = (a, b) => a < b ? -1 : a > b ? 1 : 0;
export { sortString };
//# sourceMappingURL=sortString.mjs.map
